import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import type { Suggestion } from "@/types/sections";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Stable sort for suggestions:
 * - suggestions with added_to_meeting = false first
 * - then added_to_meeting = true
 * - within each group, preserve original order
 */
export function sortSuggestionsByAddedToMeeting(
  suggestions?: Suggestion[] | null
): Suggestion[] {
  if (!Array.isArray(suggestions)) return [];

  const suggestionsWithIndex = suggestions
    .map((suggestion, index) => ({ suggestion, originalIndex: index }))
    .filter((item) => item.suggestion != null);

  return suggestionsWithIndex
    .sort((a, b) => {
      const aAdded = a.suggestion.metadata?.added_to_meeting || false;
      const bAdded = b.suggestion.metadata?.added_to_meeting || false;

      if (aAdded !== bAdded) {
        return aAdded ? 1 : -1; // false comes before true
      }

      return a.originalIndex - b.originalIndex;
    })
    .map((item) => item.suggestion);
}
